import { ConditionPredicate } from "xstate";

import { PatientSearchContext, PatientSearchEvents } from "./types";

export const arePatientsAvailable: ConditionPredicate<
  PatientSearchContext,
  PatientSearchEvents
> = (context): boolean => Boolean(context.patients);
